<template>
  <div>
    <AppBar />
    <SideBar />
    <v-container fluid>
      <v-main>
        <router-view :key="$route.path" />
      </v-main>
    </v-container>
    <notifications group="notify-group" width="500" position="top center" />
  </div>
</template>

<script>
import AppBar from './components/AppBar.vue'
import SideBar from './components/SideBar.vue'

export default {
  name: 'Layout',
  components: {
    AppBar,
    SideBar
  }
}
</script>
